var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import selectn from "selectn";

// import PrimaryImage from "../PrimaryImage";
import StoryContent from "../StoryContent";
import SaveTag from "../SaveTag";

import styles from "./SummaryCard.css";

var SummaryCard = function (_Component) {
  _inherits(SummaryCard, _Component);

  function SummaryCard() {
    _classCallCheck(this, SummaryCard);

    return _possibleConstructorReturn(this, (SummaryCard.__proto__ || Object.getPrototypeOf(SummaryCard)).apply(this, arguments));
  }

  _createClass(SummaryCard, [{
    key: "render",
    value: function render() {
      var story = this.props.story;
      if (!story) return null;
      var image = selectn("primary_image.crops.1x1.url", story);

      var summary = _extends({}, story, {
        blocks: _extends({}, story.blocks, {
          blocks: [story.blocks.blocks[0]]
        })
      });

      return React.createElement(
        "div",
        { key: story.id, className: styles.root },
        this.props.showSaveTag ? React.createElement(SaveTag, { storyId: story.id, absolute: true }) : null,
        image && React.createElement("img", { className: styles.image, src: image, alt: story.primary_image.alt_text }),
        React.createElement(StoryContent, { story: summary, isSummary: true })
      );
    }
  }]);

  return SummaryCard;
}(Component);

export default SummaryCard;


// WEBPACK FOOTER //
// ./src/components/Library/SummaryCard/SummaryCard.js